// frontend/src/components/admin/tenants/AwsRegionsModal.tsx
/**
 * Modal para selecionar as regiões AWS consultadas pelo inventário de VPN
 * de um tenant. Abre a partir do menu de ações da linha de ambiente.
 */
import { useState } from 'react'
import { Modal, MultiSelect, Text, Group, Button, Stack } from '@mantine/core'

const AWS_REGION_OPTIONS = [
  { value: 'us-east-1', label: 'us-east-1 — N. Virginia' },
  { value: 'us-east-2', label: 'us-east-2 — Ohio' },
  { value: 'us-west-1', label: 'us-west-1 — N. California' },
  { value: 'us-west-2', label: 'us-west-2 — Oregon' },
  { value: 'sa-east-1', label: 'sa-east-1 — São Paulo' },
  { value: 'eu-west-1', label: 'eu-west-1 — Irlanda' },
  { value: 'eu-central-1', label: 'eu-central-1 — Frankfurt' },
]

interface Props {
  opened: boolean
  tenantName: string
  currentRegions: string[]
  saving: boolean
  onClose: () => void
  onSave: (regions: string[]) => void
}

export function AwsRegionsModal({
  opened,
  tenantName,
  currentRegions,
  saving,
  onClose,
  onSave,
}: Props) {
  const [selected, setSelected] = useState<string[]>(currentRegions)

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Regiões AWS — ${tenantName}`}
      centered
      size="md"
    >
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          Regiões consultadas pelo inventário de VPN deste tenant.
        </Text>

        <MultiSelect
          data={AWS_REGION_OPTIONS}
          value={selected}
          onChange={setSelected}
          label="Regiões AWS"
          placeholder="Selecione uma ou mais regiões"
          searchable
          clearable
          data-testid="aws-regions-multiselect"
          disabled={saving}
        />

        <Group justify="flex-end" gap="sm">
          <Button variant="subtle" color="gray" onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button
            color="teal"
            onClick={() => onSave(selected)}
            disabled={selected.length === 0}
            loading={saving}
          >
            Salvar
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
